import React from "react";
import { AlertTriangle, X } from "lucide-react";

export default function CashScheduleDialog({
  dialogRef,
  handoff,
  form,
  errors,
  busy,
  minDateTime,
  onClose,
  onFieldChange,
  onClearFieldError,
  onSubmit,
}) {
  return (
    <div className="overlay">
      <div
        ref={dialogRef}
        tabIndex="-1"
        className="modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cash-modal-title"
      >
        <button
          type="button"
          className="close"
          aria-label="Close cash handoff dialog"
          disabled={busy}
          onClick={onClose}
        >
          <X />
        </button>
        <p className="eyebrow">Cash handoff</p>
        <h2 id="cash-modal-title">
          {handoff ? "Reschedule a safe meetup" : "Schedule a safe meetup"}
        </h2>
        <div className="cash-warning">
          <AlertTriangle size={18} />
          <span>
            Use a public, well-lit location. Do not enter a private home
            address.
          </span>
        </div>
        <form className="form" noValidate onSubmit={onSubmit}>
          <label>
            Meeting place
            <input
              name="place"
              required
              maxLength="300"
              aria-invalid={Boolean(errors.place)}
              aria-describedby={errors.place ? "cash-place-error" : undefined}
              value={form.place}
              onChange={(event) => {
                onClearFieldError("place");
                onFieldChange("place", event.target.value);
              }}
              placeholder="Example: SM City Bicutan, main entrance"
            />
          </label>
          {errors.place && (
            <p className="field-error" id="cash-place-error" role="alert">
              {errors.place}
            </p>
          )}
          <label>
            Date and time (Philippines time)
            <input
              name="time"
              type="datetime-local"
              min={minDateTime}
              required
              aria-invalid={Boolean(errors.time)}
              aria-describedby={errors.time ? "cash-time-error" : undefined}
              value={form.time}
              onChange={(event) => {
                onClearFieldError("time");
                onFieldChange("time", event.target.value);
              }}
            />
          </label>
          {errors.time && (
            <p className="field-error" id="cash-time-error" role="alert">
              {errors.time}
            </p>
          )}
          <label>
            Landmark or instructions
            <input
              name="landmark"
              maxLength="100"
              value={form.landmark}
              onChange={(event) => onFieldChange("landmark", event.target.value)}
              placeholder="Example: Beside the customer service desk"
            />
          </label>
          <p className="cash-reminder-note">
            Both participants receive an inbox confirmation when the meetup is
            scheduled or changed. For meetups scheduled in advance, reminders
            arrive about 24 hours and 1 hour beforehand.
          </p>
          <button type="submit" disabled={busy}>
            {busy
              ? "Saving..."
              : handoff
              ? "Save new meetup time"
              : "Save handoff schedule"}
          </button>
        </form>
      </div>
    </div>
  );
}
